export default {"src":"/_next/static/media/Diabetes.8eaf6520.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};